import { Analytics } from '../../views/ts/components/Analytics';
import { CookiesConsent } from '../../views/twig/components/CookiesConsent';
import { Collapse } from '../../views/ts/components/Collapse';
import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { Footer } from '../twig/components/Footer';
import { HomeScreen } from '../twig/components/HomeScreen';
import { Header } from '../twig/components/Header';
import { Accordion } from '../twig/modules/accordion';
import { FlashTransition } from './components/FlashTransition';
import { Carousel } from './components/Carousel';
import { Map } from '../twig/modules/map';
(new Analytics()).init();
(new Collapse()).init();
(new LazyLoader()).init();
(new Footer()).init();
(new HomeScreen()).init();
(new Header()).init();
(new Accordion()).init();
(new FlashTransition()).init();
(new Carousel()).init();
(new Map()).init();
// Always at the end
(new CookiesConsent()).init();
